import TagsSummary from 'dashboard/components/TagsSummary';
import { FormUpdateTagsData } from 'dashboard/forms/FormUpdateTags';
import { Tag, TagScope } from 'dashboard/models/tag';

interface TagsProps {
  tags: Tag[];
  handleUpdateTags: (tags: FormUpdateTagsData) => void;
  tagScope?: TagScope;
}

export const Tags = ({ tags, tagScope = 'all', handleUpdateTags }: TagsProps) => {
  return (
    <TagsSummary
      tags={tags}
      tagScope={tagScope}
      handleUpdateTags={handleUpdateTags}
      data-test='module__tags'
    />
  );
};
